/* ===== ComfyThreads Blog JS ===== */

(function () {
  'use strict';

  // ── Reading Progress Bar ──
  var bar = document.querySelector('.cm-reading-progress');
  if (bar) {
    function updateBar() {
      var scrollTop = window.scrollY || window.pageYOffset;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (docH > 0 ? Math.min((scrollTop / docH) * 100, 100) : 0) + '%';
    }
    window.addEventListener('scroll', updateBar, { passive: true });
    updateBar();
  }

  // ── Get article body ──
  var articleBody = document.querySelector('.blog-post-content');
  if (!articleBody) return; // Not an article page

  // ── Reading Time ──
  var timeEl = document.querySelector('.cm-read-time');
  if (timeEl) {
    var words = (articleBody.innerText || articleBody.textContent || '').split(/\s+/).filter(Boolean).length;
    var mins = Math.max(1, Math.ceil(words / 200));
    timeEl.textContent = mins + ' min read';
  }

  // ── Lead Paragraph ──
  // Make the first paragraph stand out as an intro
  var firstPara = articleBody.querySelector('p');
  if (firstPara) {
    firstPara.classList.add('cm-lead-para');
  }

  // ── Table of Contents ──
  var headings = Array.from(articleBody.querySelectorAll('h2'));
  if (headings.length >= 3) {
    // Add anchor IDs to each H2
    headings.forEach(function (h, i) {
      if (!h.id) {
        var slug = (h.textContent || '')
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .substring(0, 60);
        h.id = slug || ('cm-section-' + i);
      }
    });

    // Build TOC items
    var items = headings.map(function (h) {
      return '<li><a href="#' + h.id + '">' + (h.textContent || '').trim() + '</a></li>';
    }).join('');

    var toc = document.createElement('div');
    toc.className = 'cm-toc-box';
    toc.innerHTML = '<p class="cm-toc-box__title">In This Article</p><ul class="cm-toc-box__list">' + items + '</ul>';

    // Insert after the first paragraph
    if (firstPara && firstPara.parentNode) {
      firstPara.parentNode.insertBefore(toc, firstPara.nextSibling);
    }
  }

  // ── Callout Box Detection ──
  // Paragraphs starting with these keywords get a styled callout treatment
  var calloutKeywords = ['note:', 'tip:', 'pro tip:', 'quick tip:', 'important:', 'keep in mind:', 'remember:', 'heads up:'];
  Array.from(articleBody.querySelectorAll('p')).forEach(function (p) {
    if (p.classList.contains('cm-lead-para')) return; // Skip lead para
    var text = (p.textContent || '').trim().toLowerCase();
    var isCallout = calloutKeywords.some(function (kw) { return text.startsWith(kw); });
    if (isCallout) {
      p.classList.add('cm-callout-box');
    }
  });

  // ── Collection Link Enhancement ──
  // Finds /collections/ links in article body and styles them as CTA buttons
  var links = articleBody.querySelectorAll('a');
  links.forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (!href.includes('/collections/')) return;

    // Don't touch links inside headings
    var parent = link.parentElement;
    if (parent && /^H[1-6]$/.test(parent.tagName)) return;

    // Don't re-process already styled links
    if (link.classList.contains('cm-collection-cta-inline')) return;

    link.classList.add('cm-collection-cta-inline');
    // Force white text via inline style — overrides any theme !important color rules
    link.style.setProperty('color', '#ffffff', 'important');
    link.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    link.style.setProperty('text-decoration', 'none', 'important');

    // Add arrow icon
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('width', '11');
    icon.setAttribute('height', '11');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '2.5');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 12h14M12 5l7 7-7 7');
    icon.appendChild(path);
    link.appendChild(icon);
  });

  // ── Scroll Reveal for Cards ──
  if ('IntersectionObserver' in window) {
    var reveals = document.querySelectorAll('.cm-related-post-card, .cm-article-col-card');
    if (reveals.length) {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            revealObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      reveals.forEach(function (el, i) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.4s ease ' + (i * 0.08) + 's, transform 0.4s ease ' + (i * 0.08) + 's';
        revealObs.observe(el);
      });
    }

    // Fade-in H2 sections as they enter view
    var h2s = articleBody.querySelectorAll('h2');
    if (h2s.length) {
      var h2Obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateX(0)';
            h2Obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      h2s.forEach(function (h) {
        h.style.opacity = '0';
        h.style.transform = 'translateX(-10px)';
        h.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
        h2Obs.observe(h);
      });
    }
  }

})();
